type GetKeyProps = {
  threadId: string;
  channelId: string;
};

class ChannelTimestampCache {
  private timestamps: Record<string, number> = {};

  private getKey(props: GetKeyProps): string {
    return `${props.threadId}:${props.channelId}`;
  }

  updateTimestamp(props: GetKeyProps): void {
    this.timestamps[this.getKey(props)] = Date.now();
  }

  getTimestamp(props: GetKeyProps): number {
    return this.timestamps[this.getKey(props)] || 0;
  }
}

export const channelTimestampCache = new ChannelTimestampCache();
